module.exports = __webpack_public_path__ + "assets/img/fothr.14104884.png";